import React from "react";
import PropTypes from "prop-types";

import { Button, Icon } from "semantic-ui-react";

import { useFeatures } from "components/FeatureFlag";
import Popper from "components/Popper";

export function PopupMenu({
  open,
  onClose,
  onOpen,
  onBack,
  hasBackButton,
  children,
  ...props
}) {
  const { style: workflowMenuStyle = undefined, icon } = useFeatures(
    "edit-workflow-configuration.workflowMenu"
  );

  return (
    <Popper
      className="hubly_bars_menu"
      hideOnScroll
      on="click"
      onClose={onClose}
      open={open}
      offset="10px 10px"
      position="bottom right"
      data-test="workflow-menu-popup"
      trigger={
        <Icon
          link
          color={workflowMenuStyle?.color || "grey"}
          name={icon || "ellipsis vertical"}
          style={{
            float: "right",
            ...(workflowMenuStyle || { fontSize: "12pt" }),
          }}
          data-dd-action-name={`Open Workflow Menu with icon ${
            icon || "ellipsis vertical"
          } and style ${
            workflowMenuStyle ? JSON.stringify(workflowMenuStyle) : "{}"
          }`}
          onClick={onOpen}
        />
      }
      {...props}
    >
      <Button.Group basic vertical labeled icon style={{ border: "none" }}>
        {hasBackButton && (
          <Button
            icon="long arrow alternate left"
            content="Back to Main Menu"
            onClick={onBack}
          />
        )}
        {children}
      </Button.Group>
    </Popper>
  );
}

PopupMenu.propTypes = {
  onOpen: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onBack: PropTypes.func,
  hasBackButton: PropTypes.bool,
  open: PropTypes.bool,
  children: PropTypes.node,
};

PopupMenu.defaultProps = {
  children: null,
  open: false,
  hasBackButton: false,
  onBack: () => {},
};

export default PopupMenu;
